import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TeacherType } from '../../../shared/types/teacher-type';
import { BilingualFallbackOption } from '../types/bilingual-fallback-opt.type';
import { TeacherOption } from '../types/teacher-opt.type';

@Component({
  selector: 'lp2-teacher-switch-modal',
  templateUrl: './teacher-switch-modal.component.html',
  styleUrls: ['./teacher-switch-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'teacher-switch-modal',
  },
})
export class TeacherSwitchModalComponent {
  public teacherType = TeacherType;

  public teacherOptions: TeacherOption[];

  public set teacherOpts(teacherOptions: TeacherOption[]) {
    this.teacherOptions = teacherOptions;
  }

  public bilingualFallbackOptions: BilingualFallbackOption[];

  public set bilingualFallbackOpts(bilingualFallbackOptions: BilingualFallbackOption[]) {
    this.bilingualFallbackOptions = bilingualFallbackOptions;
  }

  public set selectedOption(val: TeacherOption['value']) {
    this.teacherTypeControl.setValue(val);
  }

  public set selectedBilingualFallback(val: BilingualFallbackOption['value']) {
    this.bilingualFallbackControl.setValue(val);
  }

  public get isDisabledSaveButton() {
    if (this.teacherTypeControl.value === TeacherType.BILINGUAL) {
      return this.bilingualFallbackControl.invalid;
    }
    return this.teacherTypeControl.invalid && !this.teacherTypeControl.touched; 
  }

  public constructor(private activeModal: NgbActiveModal) {}

  public teacherTypeControl: FormControl = new FormControl(null, [Validators.required]);
  public bilingualFallbackControl: FormControl = new FormControl(null, [Validators.required]);

  public closeModal(): void {
    this.activeModal.close();
  }

  public saveModal(): void {
    if (this.teacherTypeControl.value === TeacherType.BILINGUAL) {
      this.activeModal.close({teacherType: this.teacherTypeControl.value, bilingualFallback: this.bilingualFallbackControl.value});
    }
    this.activeModal.close({teacherType: this.teacherTypeControl.value});
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/teacher-switch-modal/teacher-switch-modal.component.ts